import ImgArea from '../../img/area.png';
import styled from 'styled-components';

const MarginWid = styled.img`margin: 0 auto;width: 90%;`;

const Heading = styled.div`
    margin-top: 30px;
    padding: 70px 25px 90px;
    padding-left: 30px;  
    background-image: linear-gradient(0deg, #990820 0%, #ba0020 100%) !important;
    color: #fff;
`;
const PaddingTop = styled.h5`padding-top: 10px`;
// 偏差値領域
const AreaDecision = () => {
    return(
        <>
            <Heading>
                <h2>R1年～R8年 YT生土佐中合不合 偏差値領域(四谷大塚第６回模試追跡結果による)</h2>
                <h4>合格人数&ensp;&ensp;50名(合格率98%)</h4>
                <h5>最高偏差値:75.4</h5>
                <h5>最低偏差値:34.8</h5>
                <PaddingTop className="whitespaceTop">※YT卒業生&nbsp;69名中&nbsp;50名&nbsp;が土佐中へ進学、</PaddingTop>
                <PaddingTop className="whitespaceTop">　4&nbsp;名が土佐塾中(特待:3名)へ進学、残り14名が県外難関中へ進学</PaddingTop>
            </Heading>
            <div className="text-center">
                <MarginWid src={ImgArea} />
            </div>
        </>
    );
}

export default AreaDecision;